<script setup lang="ts">
import VFlex from "addeus-common-library/components/base/flex/VFlex.vue";

export interface PackCardProp {
    color?: "primary" | "bronze" | "silver" | "gold";
    headImage?: string;
    price?: number;
    precision?: number;
}

const props = withDefaults(defineProps<PackCardProp>(), {
    color: "primary",
    price: 0,
    precision: 0,
});
</script>

<template>
    <VFlex
        flex-direction="column"
        class="p-5 my-5 mx-6 pack-block"
        :class="[`has-border-${props.color}`]"
        align-items="start">
        <div class="w-100" style="position: relative">
            <img
                :src="`/images/kart/top-right-${props.color}.png`"
                class="top-right-img"
                alt="top-right-block" />
            <slot name="head">
                <img
                    :src="props.headImage"
                    alt="pack_head"
                    class="my-5 title-student"
                    style="max-height: 80px" />
            </slot>
        </div>
        <VDivider :color="props.color" class="is-align-self-stretch"></VDivider>

        <slot name="content">
            <VFlex> DEFAULT_CONTENT </VFlex>
        </slot>

        <VDivider :color="props.color" class="is-align-self-stretch"></VDivider>
        <slot name="footer">
            <PackPrice
                :price="props.price"
                :precision="props.precision"
                :text-style="{ color: props.color, size: '4' }"
                :price-style="{ color: props.color, size: '4' }"
                class="is-uppercase pt-3 has-text-weight-bold" />
        </slot>
    </VFlex>
</template>

<style lang="scss" scoped>
.w-100 {
    width: 100%;
}

.pack-block {
    position: relative;
    border-radius: 5px;

    .is-size-content {
        font-size: 1.5rem;
    }

    .top-right-img {
        position: absolute;
        top: -1.5rem;
        right: -1.5rem;
        z-index: 1;
        max-height: 100%;
    }

    @media (max-width: 700px) {
        .top-right-img {
            max-height: 70px;
        }

        .is-size-content {
            font-size: 1.2rem;
        }
    }
}
</style>
